import React from 'react';
import { Zap, Target, Gift, Globe, ShieldCheck } from 'lucide-react';
import { benefits } from '../data/mock';

const iconMap = [
  Zap,
  Target,
  Gift,
  Globe,
  ShieldCheck,
];

const Benefits = () => {
  return (
    <section id="benefits" className="py-20 md:py-28 px-4 md:px-6" style={{ background: 'var(--bg-section)' }}>
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="heading-2 mb-4">{benefits.title}</h2>
          <p className="body-large max-w-2xl mx-auto" style={{ color: 'var(--text-secondary)' }}>
            {benefits.subtitle}
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {benefits.items.map((benefit, index) => {
            const Icon = iconMap[index];
            return (
              <div 
                key={benefit.title}
                className="product-card"
              >
                <div 
                  className="w-12 h-12 rounded-xl flex items-center justify-center mb-4"
                  style={{ background: 'var(--accent-wash)' }}
                >
                  <Icon size={24} style={{ color: 'var(--accent-text)' }} />
                </div>
                <h3 className="heading-3 mb-2">{benefit.title}</h3>
                <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
                  {benefit.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
